import { render, staticRenderFns } from "./EditWidgetChartDialogComponent.vue?vue&type=template&id=13a524b5&"
import script from "./EditWidgetChartDialogComponent.vue?vue&type=script&lang=js&"
export * from "./EditWidgetChartDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports